﻿export class TableGroup {
    constructor(group) {
        this.group = group;
        this.productRows = [];
        this._number;

        this.table = document.createElement('table');
        this.table.className = 'table table-bordered table-striped ' +
            'table-hover table-price table-sm table-valign-middle';
        this.table.setAttribute('data-group', this.group.id);
        this.table.setAttribute('data-type', 'group');

        const tableThead = document.createElement('thead');
        this.table.append(tableThead);

        const tableTheadTr1 = document.createElement('tr');
        this._number = tableTheadTr1;
        tableThead.append(tableTheadTr1);
        tableTheadTr1.className = 'table-primary';
        tableTheadTr1.setAttribute('data-group', this.group.id);
        tableTheadTr1.setAttribute('data-type', 'group');
        tableTheadTr1.setAttribute('data-counter', this.group.orderNumber);

        this.headName = document.createElement('th');
        tableTheadTr1.append(this.headName);
        this.headName.colSpan = 7;
        this.headName.className = 'groupHeader';
        this.headName.textContent = `${this.group.orderNumber} ` +
            `${(this.group.name === undefined) ? '' : this.group.name}`;

        const tableTheadTr2 = document.createElement('tr');
        tableThead.append(tableTheadTr2);
        tableTheadTr2.className = 'table__row__aux';

        const tableTheadTr2Th1 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th1);

        const tableTheadTr2Th2 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th2);
        tableTheadTr2Th2.textContent = 'Артикул';

        const tableTheadTr2Th3 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th3);
        tableTheadTr2Th3.textContent = 'Наименование';

        const tableTheadTr2Th4 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th4);
        tableTheadTr2Th4.textContent = 'Ед. изм.';

        const tableTheadTr2Th5 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th5);
        tableTheadTr2Th5.textContent = 'Min, $';

        const tableTheadTr2Th6 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th6);
        tableTheadTr2Th6.textContent = 'Max, $';

        const tableTheadTr2Th7 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th7);
        tableTheadTr2Th7.textContent = 'Превью';
        tableTheadTr2Th7.className = 'thumbCol hidden';

        const tableTheadTr2Th8 = document.createElement('th');
        tableTheadTr2.append(tableTheadTr2Th8);

        this.body = document.createElement('tbody');
        this.table.append(this.body);
        this.body.className = 'sortable';
    }

    async update() {
        this.table.setAttribute('data-group', this.group.id);
        this._number.setAttribute('data-group', this.group.id);
        this._number.setAttribute('data-counter', this.group.orderNumber);

        this.headName.textContent = `${this.group.orderNumber} ` +
            `${(this.group.name === undefined) ? '' : this.group.name}`;
    }
}

export class TableGroups extends Array {
    constructor(...args) {
        super(...args);
    }

    static get [Symbol.species]() {
        return Array;
    }
}

export class ProductRow {
    constructor(product, group) {
        this.product = product;
        this.group = group;
        this.row = document.createElement('tr');
        this._sort;
        this._sortOption;
        this._art;
        this._name;
        this._metric;
        this._minPrice;
        this._price;

        this.row.setAttribute('data-id', this.product.id);
        this.row.setAttribute('data-type', "position");
        this.row.setAttribute('data-group', this.group.id);
        this.row.setAttribute('data-counter', this.product.orderNumber);
        this.row.setAttribute('data-group-counter', this.group.orderNumber);
        this.row.className = 'tr_draggable';

        const productTd1 = document.createElement('td');
        this.row.append(productTd1);
        const productSortSelect = document.createElement('select');
        this._sort = productSortSelect;
        productTd1.append(productSortSelect);
        productSortSelect.name = 'select_counter';
        productSortSelect.setAttribute('data-max-counter', this.group.products.length);
        productSortSelect.setAttribute('data-counter', this.product.orderNumber);
        productSortSelect.setAttribute('data-id', this.product.id);
        productSortSelect.setAttribute('data-group', this.group.id);

        const productSortOption = document.createElement('option');
        this._sortOption = productSortOption;
        productSortSelect.append(productSortOption);
        productSortOption.classList = 'option_counter';
        productSortOption.setAttribute('data-counter', this.product.orderNumber);
        productSortOption.textContent = this.product.orderNumber;

        const productTd2 = document.createElement('td');
        this.row.append(productTd2);

        const productTd2Link = document.createElement('a');
        this._art = productTd2Link;
        productTd2.append(productTd2Link);
        productTd2Link.href = `/price?product_id=${this.product.id}`;
        productTd2Link.textContent = this.product.art;

        const productTd3 = document.createElement('td');
        this.row.append(productTd3);

        const productTd3Link = document.createElement('a');
        this._name = productTd3Link;
        productTd3.append(productTd3Link);
        productTd3Link.href = `/price?product_id=${this.product.id}`;
        productTd3Link.textContent = this.product.name;

        const productTd4 = document.createElement('td');
        this.row.append(productTd4);

        const productTd4Link = document.createElement('a');
        this._metric = productTd4Link;
        productTd4.append(productTd4Link);
        productTd4Link.href = `/price?product_id=${this.product.id}`;
        productTd4Link.textContent = this.product.metricId;

        const productTd5 = document.createElement('td');
        this.row.append(productTd5);

        const productTd5Link = document.createElement('a');
        this._minPrice = productTd5Link;
        productTd5.append(productTd5Link);
        productTd5Link.href = `/price?product_id=${this.product.id}`;
        productTd5Link.textContent = this.product.minPrice;

        const productTd6 = document.createElement('td');
        this.row.append(productTd6);

        const productTd6Link = document.createElement('a');
        this._price = productTd6Link;
        productTd6.append(productTd6Link);
        productTd6Link.href = `/price?product_id=${this.product.id}`;
        productTd6Link.textContent = this.product.price;

        const productTd7 = document.createElement('td');
        this.row.append(productTd7);
        productTd7.className = 'thumbCell p-0 hidden';

        const productTd7ThumbBlock = document.createElement('div');
        productTd7.append(productTd7ThumbBlock);
        productTd7ThumbBlock.className = 'cursor-pointer';

        const productTd7Thumb = document.createElement('span');
        productTd7ThumbBlock.append(productTd7Thumb);
        productTd7Thumb.className = 'thumb';

        const productTd7ThumbImg = document.createElement('img');
        productTd7Thumb.append(productTd7ThumbImg);
        productTd7ThumbImg.src = './img/garold.png';
        productTd7ThumbImg.alt = 'product';
        productTd7ThumbImg.id = `img_${this.product.id}`;
        productTd7ThumbImg.setAttribute('data-size', '');
        productTd7ThumbImg.setAttribute('data-image-default', '');
        productTd7ThumbImg.width = 0;
        productTd7ThumbImg.height = 0;
    }

    async update() {
        this.row.setAttribute('data-id', this.product.id);
        this.row.setAttribute('data-group', this.group.id);
        this.row.setAttribute('data-counter', this.product.orderNumber);
        this.row.setAttribute('data-group-counter', this.group.orderNumber);

        this._sort.setAttribute('data-max-counter', this.group.products.length);
        this._sort.setAttribute('data-counter', this.product.orderNumber);
        this._sort.setAttribute('data-id', this.product.id);
        this._sort.setAttribute('data-group', this.group.id);

        this._sortOption.setAttribute('data-counter', this.product.orderNumber);
        this._sortOption.textContent = this.product.orderNumber;

        this._art.href = `/price?product_id=${this.product.id}`;
        this._art.textContent = this.product.art;

        this._name.href = `/price?product_id=${this.product.id}`;
        this._name.textContent = this.product.name;

        this._metric.href = `/price?product_id=${this.product.id}`;
        this._metric.textContent = this.product.metricId;

        this._minPrice.href = `/price?product_id=${this.product.id}`;
        this._minPrice.textContent = this.product.minPrice;

        this._price.href = `/price?product_id=${this.product.id}`;
        this._price.textContent = this.product.price;
    }
}

export class Command {
    constructor(name, action) {
        this._name = name;
        this._action = action;
    }

    Invoke(params) {
        this._params = params
        this._action(this._params);
    }
}

export class Watcher {
    constructor(type, format, url) {
        this._url = url;
        this._method = 'POST';
        this._credsValue = 'include';
        this._type = type;
        this._format = format;
        this.Status = '';

        this._timeOut = 4000;
        this._isPending = false;
        this.PollStart = async () => await this.start();
        this.PollEnd = () => this.stop();
        this.Request = () => this.request(this._type, this._format, false);
    }
    stop() {
        this._isPending = false;
    };
    async start() {
        this._isPending = true;
        return await this.request(this._type, this._format, this._isPending);
    };
    async send() {
        return await this.request(this._type, this._format, this._isPending);
    };
    timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    async request(type, format, poll) {
        let data = new FormData();
        data.append("type", type);
        data.append("format", format);

        let request = await fetch(
            `${this._url}`,
            {
                method: this._method,
                body: data,
                credentials: this._credsValue
            }
        );
        let result = await request.json();

        if (poll) {
            this.Status = result.data.status;

            if (this.Status == "Validating") {
                await this.timeout(this._timeOut);
                return await this.send();
            }
            else {
                this._isPending = false;
                return result;
            }
        }
        else {
            this._isPending = false;
            return result;
        }
    }
    static appendToModal(modal, message) {
        modal.append(`<p class="card-text">${message}</p>`);
    }
}